import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../utils/supabaseClient';
// import { Apple } from 'lucide-react';
import { Capacitor } from '@capacitor/core';
import { useModal } from '../context/ModalContext';

// 偵測平台並設定正確的 redirect URI
const getRedirectUri = () => {
  if (Capacitor.isNativePlatform()) {
    return 'com.jogather.app://callback';
  }
  // Web 版 App 掛在 /app 底下，OAuth 完成後直接回到 App 而非 landing page
  return `${window.location.origin}/app`;
};

export default function Login() {
  const navigate = useNavigate();
  const [agreed, setAgreed] = useState(false);
  const { showAlert } = useModal();

  const handleLogin = async (provider) => {
    if (!agreed) return;
    const { error } = await supabase.auth.signInWithOAuth({
      provider: provider,
      options: {
        redirectTo: getRedirectUri()
      }
    });

    if (error) {
      console.error('Login failed:', error.message);
      showAlert('錯誤', '登入失敗：' + error.message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4 sm:p-8 font-sans">
      <div className="w-full max-w-5xl bg-white rounded-3xl shadow-soft overflow-hidden flex flex-col md:flex-row min-h-[600px]">
        {/* Left Side - Branding */}
        <div className="md:w-1/2 bg-gradient-to-br from-primary-light to-primary-dark text-white p-12 flex flex-col items-center justify-center text-center">
          <div className="w-full max-w-sm mx-auto">
            <img src="/splash/logo.png" alt="Jogather logo" className="w-64 h-64 object-contain mx-auto mb-8 drop-shadow-xl" />
            <p className="text-lg text-white/95 font-medium tracking-wide">
              讓交友變得更簡單，從此揪遊不孤單
            </p>
            <p className="mt-4 text-base text-white/80 font-medium tracking-wide">
              現在登入...找到和你一起出發的人
            </p>
          </div>
        </div>

        {/* Right Side - Login Form */}
        <div className="md:w-1/2 bg-white flex justify-center items-center p-8 sm:p-12">
          <div className="w-full max-w-sm">
            <h1 className="text-3xl font-bold text-slate-800 mb-2">Login</h1>
            <p className="text-slate-500 mb-8">請選擇登入方式。</p>

            {/* 同意條款 checkbox */}
            <label className="flex items-start gap-3 mb-6 cursor-pointer">
              <input
                type="checkbox"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
                className="mt-1 w-4 h-4 accent-primary cursor-pointer shrink-0"
              />
              <span className="text-sm text-slate-500 leading-relaxed">
                我已閱讀並同意本平台的{' '}
                <span onClick={(e) => { e.stopPropagation(); navigate('/terms'); }} className="text-primary font-semibold cursor-pointer hover:underline">
                  服務條款
                </span>
                {' '}與{' '}
                <span onClick={(e) => { e.stopPropagation(); navigate('/privacy-policy'); }} className="text-primary font-semibold cursor-pointer hover:underline">
                  隱私政策
                </span>
              </span>
            </label>

            {/* 
            <button
              onClick={() => handleLogin('apple')}
              disabled={!agreed}
              className={`w-full rounded-full h-12 flex items-center justify-center gap-2 font-semibold transition-colors mb-3 ${agreed ? 'bg-slate-900 text-white hover:bg-slate-800' : 'bg-slate-200 text-slate-400 cursor-not-allowed'}`}
            >
              <Apple size={18} /> Sign in with Apple
            </button>
            */}
            <button
              onClick={() => handleLogin('google')}
              disabled={!agreed}
              className={`w-full rounded-full h-12 flex items-center justify-center gap-2 font-semibold transition-colors border ${agreed ? 'bg-white border-slate-200 text-slate-700 hover:bg-slate-50 shadow-sm' : 'bg-slate-50 border-slate-100 text-slate-400 cursor-not-allowed'}`}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" /><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" /><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05" /><path d="M12 5.38c1.62 0 3.06.56 4.21 1.66l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 12-4.53z" fill="#EA4335" /></svg>
              Google 帳號登入
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
